export const IS_PROD = process.env.USER_ENV === "production";
export const IS_LOCAL = process.env.USER_ENV === "development";

export const WEBSITE_DOMAIN = process.env.WEBSITE_DOMAIN;
export const QOOHOO_WEBSITE_DOMAIN = process.env.QOOHOO_WEBSITE_DOMAIN;

export const slugMappingHome = `${QOOHOO_WEBSITE_DOMAIN}/${process.env.SLUG_MAPPING_HOME}`;

export const isBrowser = typeof document !== "undefined";